function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step_3_svg__c{fill:#614cb4}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M92.02 32.06a.162.162 0 01-.093-.029L47.007.748a.815.815 0 00-.93 0L1.477 32.03a.163.163 0 11-.187-.266L45.89.482a1.141 1.141 0 011.3 0l44.92 31.283a.162.162 0 01-.093.3z",
  opacity: 0.607,
  fill: "#a59bc3",
  stroke: "#a59bc3",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.029 33.169l42.557-31.54L89.465 35.41 48.779 59.533l-22.09-5.035z",
  fill: "#eae9ef"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "step_3_svg__c",
  d: "M28.553 74.431H7.529a.982.982 0 110-1.964h21.024a.982.982 0 110 1.964zM15.072 70.209H7.529a.982.982 0 110-1.964h7.543a.982.982 0 010 1.964z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.184 50.736a1.228 1.228 0 01-.466-.091l-26.246-10.89V5.666a1.138 1.138 0 011.137-1.137h50.352a1.138 1.138 0 011.137 1.137v34.112l-.049.021-25.384 10.84a1.237 1.237 0 01-.481.097z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47.185 50.818a1.311 1.311 0 01-.5-.1L20.391 39.811V5.666a1.22 1.22 0 011.218-1.218h50.352a1.22 1.22 0 011.218 1.218v34.166L47.696 50.711a1.317 1.317 0 01-.511.107zM20.716 39.592l26.1 10.828a.994.994 0 00.758 0l25.284-10.8V5.666a.894.894 0 00-.893-.893H21.609a.894.894 0 00-.893.893z",
  opacity: 0.689,
  fill: "#a59bc3",
  stroke: "#a59bc3",
  strokeWidth: 0.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.695 31.735h-.033l-18.646 7.963-25.512 10.894a.823.823 0 01-.63 0L20.55 39.674l-19.1-7.926-.029-.013h-.033A1.138 1.138 0 00.25 32.872v49.377a1.138 1.138 0 001.137 1.137h90.308a1.138 1.138 0 001.137-1.137V32.872a1.138 1.138 0 00-1.137-1.137zm.812 50.514a.812.812 0 01-.812.812H1.387a.812.812 0 01-.812-.812V32.872a.814.814 0 01.781-.812l19.2 7.965L46.75 50.898a1.157 1.157 0 00.884 0l25.384-10.84 18.711-7.99a.815.815 0 01.78.812z",
  opacity: 0.458,
  fill: "#a59bc3",
  stroke: "#a59bc3",
  strokeWidth: 0.5
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "step_3_svg__c",
  d: "M44.105 37.829a2.954 2.954 0 01-1.777-.59l-.032-.024-6.693-5.125a2.974 2.974 0 113.617-4.721l4.335 3.324L53.8 17.332a2.973 2.973 0 014.169-.55l-.064.087.065-.085a2.977 2.977 0 01.55 4.169L46.469 36.669a2.975 2.975 0 01-2.364 1.16z"
});

function SvgStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.082 83.636",
    className: "w-full h-full"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgStep3;